<template>
  <a-card :bordered="false" class="m-b-20">
    <SmallSquare class="m-b-10" :content='$route.query.product_name' />
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        <a-week-picker v-else-if="search.search_date_type=='2'" @change="changeWeek" v-model:value="weekTime"  :disabledDate="disabledDate"/>
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
     <a-spin :spinning="listLoading">

  <a-card :bordered="false" class="m-b-20">
    <div class="s_flex_ali dataPanel s_bf58 p-10 m-b-60">
      <div class="flex_1">
        <div class=" bor-rad-10 p-l-20 s_po_re  p-t-20 p-b-40 s_bf m-r-20 m-l-20" :class="{active:search.type==1}" @click="search.type=1;onSearch()">
          <p class=" s_font_b s_c333 m-b-10">异常扫码次数</p>
          <p class="s_cE84848 s_font_b">{{detail.code_num}}</p>
        </div>
      </div>
      <div class="flex_1">
        <div class=" bor-rad-10 p-l-20 s_po_re  p-t-20 p-b-40 s_bf m-r-20 m-l-20" :class="{active:search.type==2}" @click="search.type=2;onSearch()">
          <p class="s_c333 s_font_b m-b-10">异常扫码人数</p>
          <p class="s_cE84848 s_font_b">{{detail.member_num}}</p>
        </div>
      </div>
      <div class="flex_1">
        <div class=" bor-rad-10 p-l-20 s_po_re  p-t-20 p-b-40 s_bf m-r-20 m-l-20" :class="{active:search.type==3}" @click="search.type=3;onSearch()">
          <p class="s_c333 s_font_b m-b-10">人均一场扫码次数</p>
          <p class="s_cE84848 s_font_b">{{detail.average}}</p>
        </div>
      </div>
    </div>
    <div ref="echartsLine" style="width:100%;height:400px"></div>
  </a-card>

  <a-card :bordered="false">
    <div ref="echartsBar" style="width:100%;height:400px"></div>
  </a-card>
     </a-spin>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { fleeingGoodsDetail } from "@/api/antiFleeing";
import { message } from "ant-design-vue";

export default {
  components: {},
  setup() {
     // 切换周
    const momentTime = inject("momentTime");
    const search = ref({
      search_date_type: "1",
      start_time: "",
      end_time: "",
      type: 1,
      product_sn:"",
      product_sku_sn:""
    });
    const state = reactive({
      list: [],
      total: 0,
      cityList:[],
      line:[],
      detail:{},
      listLoading:false,
      disabledDate:function(current) {
        return current && current > momentTime().subtract(0, 'days').endOf('day')
      },
      color: ["#02a7f0","#ffc000", "#70b603", "#8080ff", "#f59a23", "#f59a23",'#a5a5a5'],

    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      changNav();
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          break;
        case "2":
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          break;
        case "4":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
      }
    };
   
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    let columns = [
      {
        title: "排名",
        dataIndex: "ranking",
        key: "ranking",
      },
      {
        title: "商品名称",
        dataIndex: "name",
        key: "name",
      },
         {
        title: "商品规格",
        dataIndex: "product_sku_name",
        key: "product_sku_name",
      },
      {
        title: "占比",
        dataIndex: "percentage",
        key: "percentage",
      },
    ];
    var $moment = inject("momentTime");
    var $route = inject('$route');
    const getLine = async () => {
      switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case "2":
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case "3":
          search.value.start_time = $moment(search.value.search_time)
            .startOf("month")
            .format("YYYY-MM-DD");
          search.value.end_time = $moment(search.value.search_time)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
      state.listLoading=true
      let result = await fleeingGoodsDetail({
        ...search.value,
      })
        .then((res) => res.data)
        .catch((error) => error);
        state.listLoading=false
      // 整理数据
      var chartsList = [];
      state.detail=result.data
      state.total = result.data.product_num;
    //   城市
      state.cityList=result.data.cityList
    //   折线
    //  line
      state.line=result.data.lineList
      return chartsList;
    };
    // 柱图
    const echartsBar=ref('');
    // 折线图
    const echartsLine=ref('')
    var bar;
    var line;
    const changNav = async () => {
      var lines = await getLine();
      bar.setOptions({
           xAxis: {
                type: 'category',
                data: state.cityList.map(v=>v.name)
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                  color:state.color,
                data: state.cityList.map(v=>v.value),
                type: 'bar',
                showBackground: true,
                }
            ]
      })
      line.setOptions({
       xAxis: {
                type: 'category',
                data: state.line.map(v=>v.date)
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                  color:state.color,
                data: state.line.map(v=>v.num),
                type: "line",
            smooth: true,
            areaStyle: {},
                }
            ]
      })
    };
    onMounted(() => {
      search.value.search_date_type=$route.query.search_date_type
      search.value.product_sku_sn=$route.query.product_sku_sn
      search.value.product_sn=$route.query.product_sn
      search.value.search_time=$route.query.search_time
      bar = useECharts(echartsBar.value);
      line = useECharts(echartsLine.value);
      changNav(1);
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      changNav,
      onSearch,
      changeWeek,
      columns,
      echartsLine,
      echartsBar
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.active {
  border: 1px solid #bbddff;
  box-shadow: 7px 5px 22px 0px #9cb9d7;
  position: relative;
  left: -5px;
  top: -5px;
}
</style>